var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
var useStyles = makeStyles(function () { return ({
    progress: {
        zIndex: 4,
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.7)',
        transition: 'opacity 0.2s ease-in',
        display: 'flex',
        verticalAlign: 'middle',
        alignItems: 'center',
        justifyContent: 'center',
    },
    fixed: {
        position: 'fixed',
    },
}); });
var Loader = function (_a) {
    var _b;
    var isFixed = _a.isFixed, progressProps = _a.progressProps;
    var classes = useStyles();
    return (React.createElement("div", { "data-test-locator": "Loader", className: cx(classes.progress, (_b = {}, _b[classes.fixed] = isFixed, _b)) },
        React.createElement(CircularProgress, __assign({ size: 50, color: "primary" }, progressProps))));
};
export default Loader;
//# sourceMappingURL=index.js.map